module.exports = function(app) {

    // shows a dropdown list that displays a list of matches based on input; updates on keystroke

    app.directive('suggest', ['$q', '$timeout', '$document', function ($q, $timeout, $document) {

        var active = [];
        var lastSearch = "";

        $(window).on('click', function (evt) {
            // Loop through active array
            for (var i = 0; i < active.length; i++) {
                $scope = active[i].scope;
                $element = active[i].element;

                // Unknown item, missing blurConfig, delete
                // TODO: track down where these are coming from, eliminate
                if (!$scope.blurConfig) {
                    active.splice(i,1);
                    i--;
                    continue;
                }

                // Delete items that no longer exist on the page
                if (!$.contains(document.body, $element[0])) {
                    active.splice(i,1);
                    i--;
                    continue;
                }

                //the root of this instance of the directive
                var dirRoot = $('#' + $scope.blurConfig.parentId)[0];

                //if user clicks outside of the sidebar, then blur
                if (dirRoot && !dirRoot.contains(evt.target)) {
                    // Only search if the the value has changed
                    if ($scope.inputValue.value !== lastSearch) {
                        lastSearch = $scope.inputValue.value;
                        $scope.blurConfig.blur(); //fires when you click outside of directive completely
                    }
                }
            }

        });

        return {
            replace: false,
            scope: {
                id: "=",
                inputValue : "=ngModel",
                maxLength:"=?",
                label: "=",
                underlabel: "=?",
                limit : "=?",
                getListItems : "&",
                placeholder : "=?",
                hideButton : "=?",
                highlightInput: "=?",
                submit: "&",
                customBlur: "=?",
                customFocus: '&?',
                autopopulateValue: '=?',
                blurConfig: '=?'
            },
            template:
            '<div name="autocomplete">' +

            '<label for="search">{{label}}</label>'+

            '<input type="text" maxlength={{maxLength}} class="search"' +
            'name="search" data-ng-keydown="keypress($event)"'+
            'aria-label="search" aria-haspopup="false" role="combobox"' +
            'spellcheck="false"' +
            'data-ng-model="inputValue.value"'+
            'data-ng-model-options="{allowInvalid : true, updateOn: \'default keypress\'}"' +
            'data-ng-change="update(inputValue.value)"' +
            'data-ng-class="{fullwidth : hideButton}"'+
            'data-ng-focus="focusAction()"' +
            'data-ng-blur="customBlur()"' +
            'data-ng-attr-placeholder="{{placeholder}}" />'+


            '<label data-ng-if="!showList && underlabel" for="under search" data-compile="underlabel"></label>'+

            '<button type="button" class="primary predictiveButton mobileOff" data-ng-if="!hideButton" data-ng-click="submit()">Search</button>'+

            '<ul role="listbox" aria-label="options"' +
            'id="searchOptions" class="autocomplete" data-ng-class="{fullwidth : hideButton}" data-ng-show="showList" aria-activedescendant="searchOptions1" data-ng-class="{visible:showList}">'+
            '<li role="option" data-ng-attr-id="searchOptions{{$index}}" data-ng-repeat="item in list | limitTo: limit track by $index" data-ng-class="{selected:counter === $index + 1}" data-ng-click="listItemClick($index)">' +
            '<span data-ng-if="highlightInput" data-ng-bind-html="item.name | highlight:inputValue.value"></span>' +
            '<span data-ng-if="!highlightInput" data-ng-bind-html="item.name"></span>' +
            '</li>'+
            '</ul>'+

            '<button type="button" class="primary predictiveButton mobileOn" data-ng-if="!hideButton" data-ng-click="submit()">Search</button>'+

            '</div>',

            link : function($scope, $element, attrs) {

                active.push({scope: $scope, element: $element});

                $element.on('focusout', function () {
                    $timeout(function () {
                        $scope.showList = false;
                    }, 250);
                });

                $element.on('focus', function () {
                    if ($scope.list.length > 1 && $scope.inputValue.value !== "") {
                        $scope.showList = true;
                    }
                });

                $scope.maxLength = angular.isDefined($scope.maxLength) ? $scope.maxLength : 255;
                $scope.list = [];
                $scope.limit = $scope.limit || 10;
                $scope.showList = false;
                $scope.blocked = false;
                $scope.counter = 0;
                $scope.placeholder = $scope.placeholder || "";
                $scope.highlightInput = $scope.highlightInput || false;

                $scope.blurAction = function () {
                    if (attrs.hasOwnProperty('customBlur')) {
                        $scope.customBlur();
                    }
                    $("ul[role='listbox']").blur();
                };

                $scope.focusAction = function () {
                    if (attrs.hasOwnProperty('customFocus')) {
                        $scope.customFocus();
                    }
                    //add directive default focus actions here

                };

                if (!$scope.getListItems) {
                    $scope.getListItems = function () {
                        return [];
                    };
                }

                $scope.listItemClick = function (index) {
                    $scope.inputValue.value = $scope.list[index].value;
                    $scope.showList = false;
                    $scope.submit();
                };

                $scope.keypress = function (event) {
                    var ENTER = 13,
                        KEYUP = 38,
                        KEYDOWN = 40,
                        TAB = 9;

                    switch(event.keyCode) {
                        case KEYUP:
                            $scope.blocked = true;
                            $scope.counter = ($scope.counter === 0) ? $scope.limit : $scope.counter - 1;
                            $scope.inputValue.value = ($scope.counter == 0) ? $scope.inputValue.entered : $scope.list[$scope.counter-1].value;
                            $scope.showList = true;
                            event.preventDefault();
                            break;
                        case KEYDOWN:
                            $scope.blocked = true;
                            $scope.counter = ($scope.counter < $scope.limit) ? $scope.counter + 1 : 0;
                            $scope.inputValue.value = ($scope.counter == 0) ? $scope.inputValue.entered : $scope.list[$scope.counter-1].value;
                            $scope.showList = true;
                            event.preventDefault();
                            break;
                        case ENTER:
                            $scope.showList = false;
                            $scope.submit($scope.inputValue.value);
                            break;
                        case TAB:
                            if($scope.showList === true){
                                $scope.submit($scope.inputValue.value);
                            }
                            break;
                        default:
                            $scope.blocked = false;
                    }
                };

                $scope.update = function (newVal) {

                    if (!$scope.blocked	// don't trigger on arrowing through list
                        && newVal !== "") { // don't trigger on empty list

                        $q.when($scope.getListItems(newVal)).then(function (matches) {
                            if (matches && matches.length > 0) {
                                $scope.showList = true;
                                $scope.list = matches;
                                $scope.inputValue.entered = newVal;
                                $scope.counter = 0;
                            } else {
                                $scope.showList = false;
                                $scope.list = [];
                            }
                        });
                    }
                };

                //if passed through value, then update input
                if (attrs.hasOwnProperty('autopopulateValue')) {
                    $scope.inputValue.value = $scope.autopopulateValue;
                }
            }
        };
    }]);
};